import List from '../../../components/Purchasing/VendorQuotes/List'
import PageTitle from '../../../elements/PageTitle'
import {Breadcrumb, Card, Layout, Row} from 'antd'
import React, {Fragment} from 'react'
import useTitle from "../../../elements/Hooks/useTitle";

const {Content} = Layout

function VendorQuotes(props) {
  useTitle('Quotes')
  return (
    <>
      <Content style={{margin: '0px 0px'}}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/purchasing/suppliers/list">Vendors</Breadcrumb.Item>
              <Breadcrumb.Item>Vendor Quotes</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Vendor Quotes'}
              subtitle={'List of Vendor Quotes'}
              color={'#FF6138'}
              iconType={'file-unknown'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{padding: 10}}>
          <Card>
            <List {...props} />
          </Card>
        </Row>
      </Content>
    </>
  )
}

VendorQuotes.propTypes = {}
VendorQuotes.defaultProps = {}

export default VendorQuotes
